import React from 'react';
import PrimaryAuthCustomizer from './index';
import { isAdjacentAoneAuthClient } from '../../utils/app-utils';
import { createWrapper } from '../../utils/react-utils';
import Header from '../../components/common/Header';
import Footer from '../../components/primary-auth/Footer';
import AthenaConnectUserIdentifier from '../../components/primary-auth/AthenaConnectUserIdentifier';
import { getLocalizedString } from '../../utils/i18n-utils';
import { getAuthenticatorMethodType, isPrimaryAuthController } from '../../utils/widget-facade';
import { APP_TYPES } from '../../constants';
import { getUserStartLoginWorkflowCookie } from '../../utils/storage-utils';

export default class AdjacentAoneAuthCustomizer extends PrimaryAuthCustomizer {
  allowRegistration = settings.appType === APP_TYPES.ADJACENT_AONE_ATHENISTA_AUTH;

  async shouldCustomize() {
    return isAdjacentAoneAuthClient() && isPrimaryAuthController(this.context?.controller);
  }

  protected addTitleMessage() {
    const titleMessage = getLocalizedString('primaryauth.titlemessage');
    const forgeHeader: JQuery<HTMLElement> = jQueryCourage('#athena-o-form-head');
    const container = createWrapper({ hidden: false });
    forgeHeader.after(container);
    this.renderReactComponent({
      id: 'okta-form-titlemessage',
      component: (
        <Header
          headerText={titleMessage}
          fontSize="default"
          fontColor="default"
          fontWeight="regular"
        />
      ),
      container,
    });
  }

  protected getFooter(): React.JSX.Element {
    const showForgotPasswordInFooter = getAuthenticatorMethodType() === 'password'
      && this.context?.controller !== 'mfa-verify-password';
    return (
      <Footer
        footerLinks={jQueryCourage('.js-cancel')}
        forgotPasswordLink={showForgotPasswordInFooter}
      />
    );
  }

  private addUserIdentifier(identifier?: string) {
    const passwordFieldset: JQuery<HTMLElement> = jQueryCourage('[data-se="o-form-fieldset-credentials.passcode"]');
    if (passwordFieldset.length) {
      const container = createWrapper({ hidden: false });
      passwordFieldset.before(container);
      this.renderReactComponent({
        id: 'athena-connect-user-identifier',
        container,
        component: <AthenaConnectUserIdentifier identifier={identifier} />,
      });
    }
  }

  async customize() {
    const identifier = this.context?.identifier || getUserStartLoginWorkflowCookie();
    await super.customize();
    if (this.context?.controller === 'mfa-verify-password') {
      this.addUserIdentifier(identifier);
      this.addForgotPasswordLink();
    }
  }
}
